/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Drop_Out_BtnInputs */



/**
* | output |
* | --- |
* | "Drop Out" |
*
* @param {Tournament_Drop_Out_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_drop_out_btn = /** @type {((inputs?: Tournament_Drop_Out_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Drop_Out_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirarse")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desistir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandona")
	return /** @type {LocalizedString} */ ("Drop Out")
});